import { render } from "./PaySign.vue?vue&type=template&id=f66d6a36&scoped=true&ts=true"
import script from "./PaySign.vue?vue&type=script&lang=ts"
export * from "./PaySign.vue?vue&type=script&lang=ts"

import "./PaySign.vue?vue&type=style&index=0&id=f66d6a36&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66d6a36"]])

export default __exports__